import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const finalGradeAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = finalGradeAdapter.getInitialState()

export const finalGradeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getFinalGrades: builder.query({
            query: () => ({
                url: '/api/final-grade',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: ['FinalGradeList'],
        }),

        // addNewQuestionSet: builder.mutation({
        //     query: initialQuestionSet => ({
        //         url: '/api/question-sets',
        //         method: 'POST',
        //         body: {
        //             ...initialQuestionSet,
        //         }
        //     }),
        //     invalidatesTags: [
        //         { type: 'QuestionSet', id: "LIST" }
        //     ]
        // }),

        updateGroupGrade: builder.mutation({
            query: initialGroupGrade => ({
                url: '/api/group-grade',
                method: 'PATCH',
                body: {
                    ...initialGroupGrade,
                }
            }),
            invalidatesTags: ['FinalGradeList'],
        }),
        // deleteQuestionSet: builder.mutation({
        //     query: ({ id }) => ({
        //         url: `/api/question-sets`,
        //         method: 'DELETE',
        //         body: { id }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'QuestionSet', id: arg.id }
        //     ]
        // }),
        generateFinalGrade: builder.mutation({
            query: initialFinalGrade => ({
                url: '/api/final-grade/generate',
                method: 'POST',
                body: {
                    ...initialFinalGrade,
                }
            }),
            // invalidatesTags: [
            //     { type: 'QuestionSet', id: "LIST" }
            // ]
        }),

        // getFinalQuestions: builder.query({
        //     query: ({ questionSetId }) => ({
        //         url: `/api/question-sets/${questionSetId}/final`,
        //         validateStatus: (response, result) => {
        //             return response.status === 200 && !result.isError
        //         },
        //     }),
        //     providesTags: ['FinalQuestionSetList'],
        // }),
        // getFinalQuestionById: builder.query({
        //     query: ({ finalQuestionSetId }) => ({
        //         url: `/api/question-sets/final/${finalQuestionSetId}`,
        //         validateStatus: (response, result) => {
        //             return response.status === 200 && !result.isError
        //         },
        //     }),
        //     providesTags: (result, error, arg) => {
        //       return [{ type: 'FinalQuestionSetItem',  id: arg._id }]
        //     }
        //     //providesTags: ['FinalQuestionSetList'],
        // }),
        // updateFinalQuestionSet: builder.mutation({
        //     query: initialFinalQuestionSet => ({
        //         url: '/api/question-sets/final',
        //         method: 'PATCH',
        //         body: {
        //             ...initialFinalQuestionSet,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'FinalQuestionSetList' },
        //         { type: 'FinalQuestionSetItem',  id: arg._id }
        //     ]
        // }),

        // deleteFinalQuestionSet: builder.mutation({
        //     query: ({ finalQuestionSetId }) => ({
        //         url: `/api/question-sets/final`,
        //         method: 'DELETE',
        //         body: { finalQuestionSetId }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'FinalQuestionSetList' }
        //     ]
        // }),
    }),
})

export const {
    useGenerateFinalGradeMutation,
    useGetFinalGradesQuery,
    useUpdateGroupGradeMutation
    // useGetFinalGradeQuery,
    // useAddNewQuestionSetMutation,
    // useUpdateQuestionSetMutation,
    // useDeleteQuestionSetMutation,
    // useGenerateQuestionSetForUsersMutation,
    // useGetFinalQuestionsQuery,
    // useDeleteFinalQuestionSetMutation,
    // useGetFinalQuestionByIdQuery,
    // useUpdateFinalQuestionSetMutation
} = finalGradeApiSlice

// // returns the query result object
// export const selectFinalGradeResult = finalGradeApiSlice.endpoints.getFinalGrade.select()

// // creates memoized selector
// const selectFinalGradeData = createSelector(
//     selectFinalGradeResult,
//     finalGradeResult => finalGradeResult.data // normalized state object with ids & entities
// )

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//     selectAll: selectAllFinalGrade,
//     selectById: selectQuestionSetById,
//     selectIds: selectQuestionSetIds
//     // Pass in a selector that returns the finalGrade slice of state
// } = finalGradeAdapter.getSelectors(state => selectFinalGradeData(state) ?? initialState)